import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import { memo } from "react";
import { SELECT_LOADING } from "~/constants/testIDs";
export const SelectLoadingOption = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("li", {
        className: "flex w-full items-center justify-start",
        "data-testid": SELECT_LOADING,
        children: [
            /*#__PURE__*/ _jsx(Spinner, {
                className: "size-3 text-grey-12"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-1.5 text-14 font-medium text-grey-10",
                children: "Loading"
            })
        ]
    });
});
SelectLoadingOption.displayName = "SelectLoadingOption";
